import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Cabecera from './cabecera';
import Contenido from './contenido';
import { DEFAULT_ERROR, HEADER_MESSAGES } from './constants';

const Payment = () => {
  const reduxVoucherInfo = useSelector(state => state.voucherInfo);
  const { userToken, user } = useSelector(state => state.userInfo);
  const location = useLocation();

  const locationVoucherInfo = location.state;

  const voucherInfo = locationVoucherInfo || reduxVoucherInfo;

  const { bookingResponse, email, pagos } = voucherInfo || {};

  const bookingResult = bookingResponse?.bookingResult ?? bookingResponse;

  const isLoggedIn = Boolean(userToken);
  const isAdmin = user?.role?.name === 'admin';

  let bookingStatus;
  if (isAdmin) {
    bookingStatus = bookingResult?.id_status;
  } else if (isLoggedIn) {
    bookingStatus = bookingResult?.agency_status ?? bookingResult?.id_status;
  } else {
    bookingStatus =
      bookingResult?.notification_status ?? bookingResult?.id_status;
  }

  const operationType = pagos ? 'PAYMENT' : 'BOOKING';
  const message =
    HEADER_MESSAGES[operationType][bookingStatus] ?? DEFAULT_ERROR;
  const showBookingDetails = Boolean(message.showBookingData);

  return (
    <div
      className="minWebPadding"
      style={{ backgroundColor: 'rgb(243, 243, 243)' }}
    >
      <Cabecera
        codeLoc={bookingResult?.locator}
        code={bookingResult?.bookingCode}
        email={email}
        datos={voucherInfo}
        pagos={pagos}
        bookingStatus={bookingStatus}
        showBookingDetails={showBookingDetails}
      />
      <Contenido datos={voucherInfo} showBookingDetails={showBookingDetails} />
    </div>
  );
};

export default Payment;
